import '@styles/webdesktop/stylesheets/baseNumeric.scss';
import React from 'react';
export const NumericSeparator = () => {
    return React.createElement("span", { className: "numeric-separator", "aria-hidden": "true" });
};
